@for (seobox of seoboxes; track seobox.id) {
    <div class="toggle-element">
        @if (seobox.path) {
            <div class="content seo-blocks">
                <vn-page-matrix [path]="seobox.decodedPath" [product]="currentProduct"></vn-page-matrix>
            </div>
        }
    </div>
}
